module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"log-out":"Salir de la cuenta"},"en":{"log-out":"Log out"}}')
  delete Component.options._Ctor
}
